import { render, staticRenderFns } from "./Pt_Detail.vue?vue&type=template&id=6bd859b9&scoped=true&"
import script from "./Pt_Detail.vue?vue&type=script&lang=js&"
export * from "./Pt_Detail.vue?vue&type=script&lang=js&"
import style0 from "./Pt_Detail.vue?vue&type=style&index=0&id=6bd859b9&lang=scss&scoped=true&"
import style1 from "./Pt_Detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd859b9",
  null
  
)

export default component.exports